import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Input, FormBtn, OtherFormBtn } from '../components/form.jsx';
import { useUser } from '../UserContext.js';
import { auth, db } from '../auth.js';
import { createUserWithEmailAndPassword, updateProfile, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

const SignUpPage = () => {
    const user = useUser();
    const [nameValid, setNameValid] = useState(false);
    const [emailValid, setEmailValid] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);
    const [className, setClassName] = useState('form-btn-disabled');
    const [errMsg, setErrMsg] = useState('');
    const [display, setDisplay] = useState('none');
    const provider = new GoogleAuthProvider();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/projects', { replace: true });
        }
    }, [user, navigate]);

    const handleGoogleLogin = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                const setData = async () => {
                    const docSnap = await getDoc(doc(db, "user", result.user.uid));
                    if (!docSnap.exists()) {
                        await setDoc(doc(db, "user", result.user.uid), {
                            name: result.user.displayName,
                            projectNum: 0
                        }, { merge: true });
                    }
                }
                setData()
                    .then(() => {
                        navigate('/projects', { replace: true });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }).catch((error) => {
                const errorMsg = error.code.split('/')[1].replaceAll('-', ' ');
                setDisplay('flex');
                setErrMsg(errorMsg);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setClassName('form-btn-disabled');
        const nameVal = e.target[0].value;
        const emailVal = e.target[1].value;
        const passwordVal = e.target[2].value;
        createUserWithEmailAndPassword(auth, emailVal, passwordVal)
            .then((result) => {
                const randomNum = Math.floor((Math.random() * 53));
                const profile = "https://xsgames.co/randomusers/assets/avatars/pixel/" + randomNum + ".jpg";
                updateProfile(result.user, {
                    displayName: nameVal,
                    photoURL: profile
                }).then(() => {
                    const setData = async () => {
                        await setDoc(doc(db, "user", result.user.uid), {
                            name: nameVal,
                            projectNum: 0
                        }, { merge: true });
                    }
                    setData()
                        .then(() => {
                            signInWithEmailAndPassword(auth, emailVal, passwordVal)
                                .then(() => {
                                    navigate('/projects', { replace: true });
                                }).catch(() => {
                                    navigate('/signin', { replace: true });
                                });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }).catch((error) => {
                    console.log(error)
                });
            })
            .catch((error) => {
                const errorMsg = error.code.split('/')[1].replaceAll('-', ' ');
                setDisplay('flex');
                setErrMsg(errorMsg);
            });
    }

    function handleEmailChange(e) {
        setDisplay('none');
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(e.target.value)) {
            setEmailValid(false);
            setClassName('form-btn-disabled');
        } else {
            setEmailValid(true);
            if (nameValid && passwordValid)
                setClassName('form-btn');
        }
    }
    function handlePasswordChange(e) {
        setDisplay('none');
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+]{8,}$/;
        if (!passwordRegex.test(e.target.value)) {
            setPasswordValid(false);
            setClassName('form-btn-disabled');
        } else {
            setPasswordValid(true);
            if (nameValid && emailValid)
                setClassName('form-btn');
        }
    }
    function handleNameChange(e) {
        setDisplay('none');
        const nameRegex = /^[\w\d\u4e00-\u9fa5]{1,10}$/;
        if (!nameRegex.test(e.target.value)) {
            setNameValid(false);
            setClassName('form-btn-disabled');
        } else {
            setNameValid(true);
            if (emailValid && passwordValid)
                setClassName('form-btn');
        }
    }

    return (
        <div className="container">
            <div className="sign-form">
                <div>
                    <Link to="/signin" className='form-link'>
                        Login
                    </Link>
                    <p>/</p>
                    <h1>Register</h1>
                </div>
                <p style={{ display }}>
                    <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {errMsg}
                </p>
                <form onSubmit={handleSubmit}>
                    <Input type='name' name={nameValid} handleChange={handleNameChange} />
                    <Input type='email' email={emailValid} handleChange={handleEmailChange} />
                    <Input type='password' password={passwordValid} handleChange={handlePasswordChange} />
                    <FormBtn value='CREATE ACCOUNT' class={className} />
                    <OtherFormBtn action='Up' value='Google' handleClick={handleGoogleLogin} />
                </form>
            </div>
        </div>
    )
}

export default SignUpPage;
